import { COLUMNS_BLOCK_TYPE, ColumnsProps, IBlockDefinition, IBlockProps } from '@fox/blocks';
import { getAttributeValues, transformLegacyProps } from '../../../utils';
import { RenderBlockComponent } from '../../render-block-component';
import { useFormBlockReRenderer } from '../../use-form-block-re-renderer';
import { useConditionEvaluator } from '../form-block/conditionals/helpers';
import { ColumnStylesReference } from './content-items-columns-styles-reference';

function columnsChildren(props: ColumnsProps) {
	const columns = props?.columns ?? [];
	const { columnGap: padding, backgroundColour } = props;
	return columns.map((column, i) => {
		const layout = column?.layout;
		return (
			<div
				key={layout?.layouts?.[0]?.id}
				style={{
					gridArea: `column${i + 1}`,
					padding: padding,
					minHeight: 0,
					minWidth: 0,
					border: 'none',
					backgroundColor: backgroundColour
				}}
			>
				<div style={{ backgroundColor: 'transparent', height: '100%', width: '100%' }}>
					{layout?.layouts?.map(l => {
						return <RenderBlockComponent {...l} key={l.id} />;
					})}
				</div>
			</div>
		);
	});
}
function ColumnsBlock({ id, props, type }: IBlockProps<ColumnsProps>) {
	const normalisedProps = transformLegacyProps(type, props);
	const { attributes } = normalisedProps;

	const { top: paddingTop, bottom: paddingBottom, right: paddingRight, left: paddingLeft } = getAttributeValues(attributes.padding);
	const { top: marginTop, bottom: marginBottom, right: marginRight, left: marginLeft } = getAttributeValues(attributes.margin);

	const borderRadius = props?.borderRadius;
	const backgroundColor = props?.backgroundColour;

	const children = columnsChildren(normalisedProps);

	const numOfCols = props.columns?.length;
	const leftAligned = props.leftAligned;

	return (
		<>
			<ColumnStylesReference />

			<div style={{ paddingTop: marginTop, paddingBottom: marginBottom, height: '100%' }}>
				<div
					style={{
						display: 'grid',
						backgroundColor,
						borderRadius,
						marginLeft,
						marginRight,
						paddingTop,
						paddingRight,
						paddingBottom,
						paddingLeft
					}}
					data-stack={attributes?.columnStackingMode}
					data-numofcols={numOfCols}
					data-leftaligned={leftAligned}
				>
					{children}
				</div>
			</div>
		</>
	);
}
export const ConditionalColumnsBlock = ({ props, id, type }: IBlockProps<ColumnsProps>) => {
	useFormBlockReRenderer([], props as any);
	const shouldRender = useConditionEvaluator(props as any);
	if (!shouldRender) return null;
	return <ColumnsBlock type={type} id={id} props={props} />;
};

export const ConditionalColumnsBlockRuntime: IBlockDefinition<ColumnsProps> = {
	type: COLUMNS_BLOCK_TYPE,
	Component: ConditionalColumnsBlock
};
